import { useAccount } from '@/hooks/useAccount';

import { getBodyShapeIdByTitle } from '../Layouts/OwnAIMan/screens/BodyShape/utils/getBodyShapeIdByTitle';
import { getEthnicityIdByTitle } from '../Layouts/OwnAIMan/screens/Ethnicity/utils/getEthnicityIdByTitle';
import { getAiAgeGeneration } from '../utils/getAiAgeGeneration';

export const useManLayoutSelections = () => {
  const { user } = useAccount();

  const ageGeneration = getAiAgeGeneration(user?.onboarding_data?.age);
  const bodyShape = getBodyShapeIdByTitle(
    user?.onboarding_data?.body_shape,
    true,
  );
  const ethnicity = getEthnicityIdByTitle(
    user?.onboarding_data?.ethnicity,
    true,
  );

  return {
    ageGeneration,
    bodyShape,
    ethnicity,
  };
};
